import { useEffect } from 'react';
import { themeConfig } from '../config/theme';

/**
 * Hook pour appliquer le thème personnalisé au chargement de l'application
 */
export const useTheme = () => {
  useEffect(() => {
    // Appliquer les variables CSS personnalisées
    const root = document.documentElement;
    root.style.setProperty('--color-primary', themeConfig.colors.primary.rgb);
    root.style.setProperty('--color-primary-hover', themeConfig.colors.primary.rgbHover);
  }, []);
};

